/**
 * Slide Bar Search Filter
 */

jQuery( document ).ready( function() {
	jQuery( '#sidebar-search-results' ).on( 'click', function() {
		const searchQuery = jQuery( '#side-bar-search' ).val();
		const selectedPostType = jQuery( '#sidebar-type-option li span.active' ).data( 'post-type' );
		const selectedYear = jQuery( '#sidebar-year-option li span.active' ).data( 'year' );

		let url = '<?php echo esc_url(home_url(' / ')); ?>?s=' + searchQuery;

		if ( selectedPostType ) {
			url += '&post_type=' + selectedPostType;
		}

		if ( selectedYear ) {
			url += '&year=' + selectedYear;
		}

		window.location.href = 'asdsadasd';
	} );
} );

/**
 * Slide Bar Search Filter
 */
